import "./ButtonPromotedBlock.scss";
import {
  BlockTop,
  ButtonPromotedItemBlock,
  GridPresetOneHalf,
  GridPresetOneThird,
  GridPresetWideContent,
  GridRow,
  OptimizelyEditProperty,
} from "/App.Components";
import { ButtonPromotedBlockProps } from "/Models/Generated/ButtonPromotedBlockProps";
import { RowSpacing } from "/Components/Layout/GridRow/GridRow";

const ButtonsGroupBlock = ({
  buttonsPerRow,
  blockTop,
  items,
  itemsPropertyName,
  theme,
}: ButtonPromotedBlockProps) => {
  const ColumnComponent =
    buttonsPerRow === 1
      ? GridPresetWideContent
      : buttonsPerRow === 2
        ? GridPresetOneHalf
        : GridPresetOneThird;
  return (
    <div className={"button-promoted-block-norad"}>
      <GridRow>
        {blockTop && (
          <GridPresetWideContent>
            <BlockTop {...blockTop} />
          </GridPresetWideContent>
        )}
      </GridRow>
      <OptimizelyEditProperty propertyName={itemsPropertyName} clientRender>
        <GridRow rowSpacing={RowSpacing.xs}>
          {(items?.length ?? 0) > 0 &&
            items?.map((item, idx) => (
              <ColumnComponent key={idx}>
                <ButtonPromotedItemBlock {...item} theme={theme} />
              </ColumnComponent>
            ))}
        </GridRow>
      </OptimizelyEditProperty>
    </div>
  );
};

export default ButtonsGroupBlock;
